import { render, staticRenderFns } from "./ISPDashboardOneDevice.vue?vue&type=template&id=19c5fc08&"
import script from "./ISPDashboardOneDevice.vue?vue&type=script&lang=js&"
export * from "./ISPDashboardOneDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports